<template>
  <div class="home py-5">
		<span class="d-flex flex-row page-title">{{$t("intranet.title.page.changelog.list")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <div class="d-flex justify-start mt-4 mr-16">
        <v-select
          v-model="componentFilter"
          :items="[{text:$t(`aveine-changelog.components.all`), value:null},
                    {text:$t(`aveine-changelog.components.android`), value:'android'},
                    {text:$t(`aveine-changelog.components.ios`), value:'ios'},
                    {text:$t(`aveine-changelog.components.aerator_original`), value:'aveine_original'},
                    {text:$t(`aveine-changelog.components.aerator_estl`), value:'aveine_estl'},
                    {text:$t(`aveine-changelog.components.intranet`), value:'intranet'},
                    {text:$t(`aveine-changelog.components.aveine_space`), value:'aveine_space'}]"
          :label="$t('aveine-changelog.title.filters')"
        ></v-select>
      </div>
      <AveineChangelogList :APIbaseURL="APIbaseURL" :changelogs="this.changelogs" :adminMode="true"/>
      <div class="text-center">
        <v-pagination
          v-model="currentPage"
          :length="paginationLength"
          :total-visible="paginationLength < 7 ? paginationLength : 7"
        ></v-pagination>
      </div>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineChangelogList } from 'aveine-changelog'
import { Changelog } from 'aveine-toolbox'
import { marked } from 'marked';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      changelogs: [],
      componentFilter: null,
      currentPage: this.$route.query.page,
      paginationLength: 0,
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },

  name: 'Index',
  components: {
    AveineChangelogList
  },
  watch: {
    componentFilter (value) {
      this.loadChangelogs(value);
    }
  },
  
  async mounted() {
    this.loadChangelogs();
  },
  methods: {
    async loadChangelogs (componentFilter) {
      try {
        this.changelogs = [];
        this.dataLoaded = false;
        
        let params =  
        {
          "sort": "-created-at",
          "page[number]": this.$route.params.page || 1,
          "page[size]": 50,
        };

        if (componentFilter)
          params["filter[component]"] = componentFilter

        let changelogs = await Changelog.api().get(`changelogs?lang=${this.$i18n.locale}`, {
            baseURL: this.APIbaseURL,
            params
          }
        );

        const that = this;
        changelogs.response.data.map(async function(data){
          let changelog = await Changelog.query().whereId(data.id).withAllRecursive().first();
          Object.keys(changelog.markdown).map(function(lang){
            if (changelog.markdown[lang]) {
              changelog.markdown[lang] = marked(changelog.markdown[lang], { sanitize: true })
            }
          })
          that.changelogs.push(changelog);
        })
        this.dataLoaded = true;
      } catch (errors) {
        this.dataLoaded = true;
        errorHandler(errors, this)
      }
    }
  },
}
</script>
